import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'
import { AppAuthService, UsersService } from '@prodcard/core'
import { handleError } from '../../../helpers'
import PasswordChangeForm from './PasswordChangeForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordChangePage',
  props: {
    authService: {},
    usersService: {},
    redirect: { default: '/' }
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()

const changed = () => {
  handleError(async () => {
    await router?.push({ path: props.redirect ?? '/' })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { width: "500" }, {
    default: _withCtx(() => [
      _createVNode(PasswordChangeForm, {
        "auth-service": _ctx.authService,
        "users-service": _ctx.usersService,
        onChanged: changed
      }, null, 8, ["auth-service", "users-service"])
    ]),
    _: 1
  }))
}
}

})